import { FormMessage } from '../form';
import { cn } from '@/lib/utils';
import { useCheckFormikError } from '@/hooks/formik/useCheckFormikError';

export type FormErrorProps = {
  name: string;
  className?: string;
};

export const FormError = ({ className, name }: FormErrorProps) => {
  const { error } = useCheckFormikError({ name });

  if (!error) {
    return null;
  }

  return (
    <FormMessage
      type="error"
      className={cn('mt-2', className)}
      data-testid={`form-error-${name}`}
    >
      {error instanceof Object ? 'Invalid input' : error}
    </FormMessage>
  );
};
